import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Loading from '../../components/common/Loading';
import Error from '../../components/common/Error';

import { useSessionContext } from '../../contexts/SessionContext';


export default function InventoryDashboardPage( props ){
    //console.debug("RTS Break InventoryDashboardPage");

    const {curFilter, user, sessionCustomer, userAuthToken, apiRoot} = useSessionContext();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);

    const [filter, setFilter] = useState();
    const [data, setData] = useState([]);


    // const fetchData = useCallback((pFilter) => {
    //     setIsLoading(true);
    //     let apiURL = apiRoot + "/Assets/GetAssetSummary";
    //     axios
    //     .post(
    //         apiURL,
    //         pFilter, 
    //         {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
    //     )
    //     .then(response => {
    //         if (response.data) {
    //             setIsLoading(false);
    //             setData(response.data);
    //         }
    //     })
    //     .catch(error => {
    //         console.log("RTS Data Error", error);
    //         setHasError(true);
    //     });
    // }, [apiRoot, userAuthToken.token]);
    

    useEffect(() => {
        props.setIsModalFx(false);
        if(curFilter != null && curFilter.key === 'InventoryDashboardPage'){
            setFilter(curFilter.filter);
            //fetchData(curFilter.filter);
        }
        else{
            setFilter({user:user, customer:sessionCustomer.customer, status:-1, sortBy:0});
            //fetchData({user:user, customer:sessionCustomer.customer, status:-1, sortBy:0})
        }

        setIsLoading(false);
    }, [props]);  


    const setTableHeight = () => {
        let retValue;

        if(smallForm){
            retValue = 'auto';
        }
        else{
            retValue = '80vh';
        }
        return retValue;
    }; 


    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }

    return(
        <Box>
            {/* <AssetsFilter filter={filter} setFilterFx={setFilter}/> */}
            <Box sx={{mt:2, height:setTableHeight(), minHeight:'500px'}}>           
                {/* <AssetsList data={data} /> */}
                DASHBOARD PAGE
            </Box>
        </Box>
    );
}
